export default "__VITE_ASSET__L95U4uic__"